/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const containerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {},

  button: {
    borderRadius: '4px',
  },
});

export const containerPaddingCss = css({
  padding: '128px 0',
  margin: '128px 0px 0px',

  button: {
    [MediaQueries.sm]: {
      borderRadius: '4px',
    },
  },
  [MediaQueries.sm]: {
    padding: '48px 0',
    margin: '64px 0px 0px',
  },
  [MediaQueries.md]: {
    padding: '96px 0',
    marginBottom: '96px',
  },
  [MediaQueries.lg]: {
    padding: '96px 0',
    marginBottom: '96px',
  },
});

export const headlineCss = css(typography.effra48, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  position: 'relative',
  marginBottom: '24px',
});

export const bodyCss = css(typography.effra18, {
  color: '#888888',
  marginBottom: '16px',
});

export const contactCss = css({
  marginBottom: '32',
  '.Callussection': {
    display: 'flex',
    textDecoration: 'none',
    color: '#393939',
    height: '56px',
    alignItems: 'center',
    marginBottom: '16px',

    '.callustxt': { margin: '0 16px 0 10px', fontWeight: '500' },
  },
});
